<div class="curtain">
    <section class="component-modalDialog editDocxDialog redesigned size-6">

        <header>
            Editace dokumentu online
            <a class="closeModalDialog fa fa-close" (click)="closeModal(false)"></a>
        </header>

        <div class="contentContainer scrollable nativeScrollbar inside">
<!--            <ca-loading  [load-state]="uploadingToSharepoint" [loadText]="'Připravuji online editaci'">-->
<!--            </ca-loading>-->

            <div class="component-loadingBox" *ngIf="uploadingToSharepoint">
                <div class="spinner"></div>
                <p>Probíhá načítání dat...</p>
            </div>

            <div class="col-full no-height">
                <p class="message"><strong>Průběh editace:</strong></p>
                <ul class="asUl">
                    <li>Online dokument se automaticky ukládá. Není nutné používat tlačítko uložit.</li>
                    <li>Po ukončení práce v online editoru přeneste soubor do aplikace tlačítkem <span class="fa fa-cloud-download"></span></li>
                </ul>
            </div>

            <div class="col-full no-height flex flex-center">
                <form>
                    <input
                            type="checkbox"
                            name="isDocxPopupEnabled"
                            value="docxPopupEnabled"
                            id="stopDocxPopup"
                            (click)="toggleDocxPopupEnabled();"
                            [checked]="docxPopupEnabled">
                    <label
                            for="stopDocxPopup"
                            class="showAsCheckbox withLabel"
                            title="Příště nezobrazovat">
                        Příště nezobrazovat
                    </label>
                </form>
            </div>
        </div>

        <footer *ngIf="!uploadingToSharepoint">
            <a class="button-primary"
               [ngClass]="{'disabled': uploadingToSharepoint || !onlineDocumentLink.length}"
               (click)="openSharedLink()"
               >Otevřít online editaci</a>
            <a class="button-secondary" (click)="closeModal(null)">Zavřít</a>
        </footer>
    </section>
</div>